const isPromise = (value) => {
  return typeof value === "object" && value !== null && "then" in value && typeof value.then === "function";
};
const tryCatch = async (promiseOrCallback) => {
  try {
    const promise = isPromise(promiseOrCallback) ? promiseOrCallback : Promise.resolve(promiseOrCallback());
    const data = await promise;
    return { data, error: void 0 };
  } catch (error) {
    return { data: void 0, error };
  }
};
const tryCatchSync = (callback) => {
  try {
    const data = callback();
    return { data, error: void 0 };
  } catch (error) {
    return { data: void 0, error };
  }
};
const syncFunction = (callback) => {
  const promise = Promise.resolve(callback());
  promise.catch((error) => {
    console.error(error);
  });
};
export {
  isPromise,
  syncFunction,
  tryCatch,
  tryCatchSync
};
//# sourceMappingURL=function.mjs.map
